export default {
  bgColor: '#fff',
  txtColor: '#614D4A',
}



// WEBPACK FOOTER //
// ./src/assets/styles/themes/default.js